import {statAnatomy} from '@chakra-ui/anatomy';
import {createMultiStyleConfigHelpers, defineCssVars} from '@chakra-ui/styled-system';
import {useMultiStyleConfig} from '@chakra-ui/system';

const anatomyKeys = [...statAnatomy.keys, `chart`] as const;
const {defineMultiStyleConfig} = createMultiStyleConfigHelpers(anatomyKeys);

const {fontSize: $fontSize} = defineCssVars(`stat`, [`fontSize`]);

export const StatTheme = defineMultiStyleConfig({
  baseStyle: {
    container: {
      fontSize: $fontSize.reference,
    },
    chart: {
      width: `100%`,
    },
    label: {
      // TODO: check why setting this up has no effect (overridden in the feature level)
      [$fontSize.variable]: `fontSizes.md`,
      color: `text.muted`,
      mb: `8`,
    },
    number: {
      fontWeight: `light`,
    },
  },
  variants: {},
  defaultProps: {
    size: `md`,
  },
});

export default StatTheme;

export const useStatStyle = (part: (typeof anatomyKeys)[number], props: Parameters<typeof useMultiStyleConfig>[1]) => {
  return useMultiStyleConfig(`Stat.${part}`, props);
};
